import React from 'react';
import './Contact.css'; // Make sure to import the CSS file

const Contact = () => {
  return (
    <div className="background-wrapper">
    <div className="contact-container">
      <h1 className="contact-heading">מוזמנים ליצור איתנו קשר</h1>
      <div className="contact-info">
        <p>
          <strong>בטלפון</strong>
          <span className="contact-detail">054-2317742</span>
        </p>
        <p>
          <strong>בווצאפ</strong>
          <a
          href="https://wa.me/0542317742?text=%D7%90%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A9%D7%9E%D7%95%D7%A2%20%D7%A2%D7%9C%20%D7%A9%D7%99%D7%A8%D7%95%D7%AA%20%D7%9E%D7%A2%D7%A7%D7%91%20%D7%9E%D7%95%D7%96%D7%9E%D7%A0%D7%99%D7%9D%20%D7%A9%D7%90%D7%AA%D7%9D%20%D7%9E%D7%A6%D7%99%D7%A2%D7%99%D7%9D%3A"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-detail"
        >
          שליחת הודעה
        </a>        </p>
        <p>
          <strong>או במייל</strong>
          <span className="contact-detail">mariagefamily.il@gmail.com</span>
        </p>
      </div>
      </div>
    </div>
  );
};

export default Contact;
